var _g, _g2, _g3, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgNoNotification = function SvgNoNotification(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 252,
    height: 181,
    viewBox: "0 0 252 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M223 33C230.732 33 237 26.732 237 19C237 11.268 230.732 5 223 5C215.268 5 209 11.268 209 19C209 26.732 215.268 33 223 33Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.222,
    y: 11.2222,
    width: 24,
    height: 24,
    fill: "url(#pattern0)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.5 159C96.0604 159 103 152.06 103 143.5C103 134.94 96.0604 128 87.5 128C78.9396 128 72 134.94 72 143.5C72 152.06 78.9396 159 87.5 159Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.7192 151.099C88.0871 151.43 88.6317 151.426 88.9951 151.091C90.8599 149.371 96.1949 144.177 96.1949 141.05C96.1949 139.084 95.0058 137.073 92.4178 137.073C90.3194 137.073 88.3608 139.665 88.3608 139.665C88.3608 139.665 86.4023 137.073 84.3039 137.073C81.7158 137.073 80.3169 139.099 80.3169 141.05C80.3169 144.182 85.8132 149.388 87.7192 151.099Z",
    stroke: "white",
    strokeWidth: 1.1
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25 63C32.1797 63 38 57.1797 38 50C38 42.8203 32.1797 37 25 37C17.8203 37 12 42.8203 12 50C12 57.1797 17.8203 63 25 63Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3569 56.3726C30.565 56.3726 30.7353 56.1942 30.7353 55.9762V54.9653C30.7353 53.3796 29.9218 51.9128 28.6353 51.12L28.5975 51.1001C26.1948 49.6334 23.2057 49.6334 20.8031 51.1001L20.7652 51.12C19.4409 51.9128 18.6274 53.3994 18.6274 54.9653V55.9762C18.6274 56.1942 18.7977 56.3726 19.0058 56.3726C19.2139 56.3726 19.3842 56.1942 19.3842 55.9762V54.9653C19.3842 53.6769 20.0463 52.448 21.1247 51.8137L21.1625 51.7939C23.3381 50.4659 26.0246 50.4659 28.2002 51.7939L28.238 51.8137C29.3164 52.4678 29.9785 53.6769 29.9785 54.9653V55.9762C29.9785 56.1942 30.1488 56.3726 30.3569 56.3726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1648 47.9195C26.6529 48.8121 25.7049 49.3628 24.6811 49.3628C23.6573 49.3628 22.7093 48.8121 22.1974 47.9385C21.6855 47.0649 21.6855 45.9634 22.1974 45.0708C22.7093 44.1782 23.6573 43.6275 24.6811 43.6275C25.7049 43.6275 26.6529 44.1782 27.1648 45.0518C27.6767 45.9254 27.6767 47.0269 27.1648 47.9195ZM24.6811 44.3871C23.9417 44.3871 23.2402 44.8049 22.861 45.4506C22.4818 46.0963 22.4818 46.894 22.861 47.5586C23.2402 48.2233 23.9417 48.6221 24.6811 48.6221C25.4206 48.6221 26.1221 48.2043 26.5013 47.5586C26.8804 46.913 26.8804 46.0963 26.5013 45.4506C26.1221 44.786 25.4206 44.3871 24.6811 44.3871Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.949 75.5745C139.243 41.7959 47.7375 -23.4003 30.7497 8.59409C13.7619 40.5885 30.0936 100.634 65.6937 116.01C101.294 131.386 142.654 109.353 140.949 75.5745Z",
    fill: "#FF5E6D",
    fillOpacity: 0.08
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.0522 76.755C81.2864 53.4718 201.161 8.53285 223.415 30.5862C245.669 52.6396 240.036 99.0263 193.399 109.625C146.763 120.223 76.818 100.038 79.0522 76.755Z",
    fill: "#FF5E6D",
    fillOpacity: 0.189658
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M131.642 93.3584C136.601 92.2135 139.692 87.2644 138.547 82.3043C137.402 77.3441 132.454 74.2512 127.495 75.3961C122.536 76.5409 119.444 81.49 120.59 86.4501C121.735 91.4103 126.683 94.5032 131.642 93.3584Z",
    fill: "url(#paint3_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M127.475 75.4007C122.787 76.4829 119.766 80.9566 120.401 85.6322L132.46 93.1696C136.939 91.69 139.634 87.013 138.552 82.3245C137.404 77.3531 132.445 74.2533 127.475 75.4007Z",
    fill: "url(#paint4_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M154.66 62.0297L96.4719 75.4634C92.4979 76.3809 90.0113 80.3078 90.9179 84.2347C91.8244 88.1615 95.7808 90.6011 99.7549 89.6836L157.943 76.2499C161.917 75.3324 164.403 71.4053 163.497 67.4785C162.59 63.5517 158.634 61.1122 154.66 62.0297Z",
    fill: "url(#paint5_linear)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.759 43.8275L149.073 58.1813C149.791 61.2886 152.91 63.222 156.042 62.4988L94.6868 76.6638C97.8192 75.9407 99.7771 72.8352 99.0597 69.7279L95.7458 55.374C93.0659 43.7657 98.8522 32.1682 109.083 26.9554C108.222 26.0533 107.583 24.9186 107.283 23.6191C106.386 19.7339 108.834 15.8502 112.751 14.946C116.668 14.0418 120.571 16.459 121.468 20.3442C121.768 21.6435 121.691 22.9439 121.313 24.1319C132.793 24.3325 143.079 32.219 145.759 43.8275ZM111.538 22.6368C111.897 24.1905 113.458 25.1556 115.025 24.794C116.591 24.4324 117.571 22.8805 117.212 21.3268C116.853 19.771 115.292 18.8059 113.726 19.1675C112.159 19.5291 111.179 21.081 111.538 22.6368Z",
    fill: "url(#paint6_linear)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M105.318 52.7018C109.643 54.7394 110.705 54.4669 114.419 51.571",
    stroke: "#F23A4B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M125.348 47.2893C129.673 49.3269 130.735 49.0545 134.449 46.1585",
    stroke: "#F23A4B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.846 67.336C127.326 66.7636 128.871 64.2891 128.299 61.809C127.726 59.3289 125.252 57.7825 122.773 58.3549C120.293 58.9273 118.747 61.4019 119.32 63.8819C119.893 66.362 122.367 67.9085 124.846 67.336Z",
    fill: "#F23A4B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M91.5225 86.8542C92.7822 89.8519 96.2844 91.558 99.7766 90.4408L157.507 77.1127C161.135 76.586 163.535 73.5173 163.353 70.2708L91.5225 86.8542Z",
    fill: "url(#paint7_linear)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M144.26 11.5529L139.79 16.8982",
    stroke: "#FFBCC2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M150.305 19.2645L143.499 21.0883",
    stroke: "#FFBCC2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M136.513 8.47642L134.995 15.1705",
    stroke: "#FFBCC2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 197,
    y: 2,
    width: 54.2222,
    height: 54.2222,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.825549 0 0 0 0 0.161775 0 0 0 0 0.223617 0 0 0 0.341455 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0",
    transform: "scale(0.00416667)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 59,
    y: 124,
    width: 57,
    height: 57,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.825549 0 0 0 0 0.161775 0 0 0 0 0.223617 0 0 0 0.341455 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d",
    x: 0,
    y: 34,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.825549 0 0 0 0 0.161775 0 0 0 0 0.223617 0 0 0 0.341455 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 237,
    y1: 5,
    x2: 209,
    y2: 5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37405,
    stopColor: "#FF5E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746912,
    stopColor: "#FF4F7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 103,
    y1: 128,
    x2: 72,
    y2: 128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37405,
    stopColor: "#FF5E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746912,
    stopColor: "#FF4F7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 38,
    y1: 37,
    x2: 12,
    y2: 37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37405,
    stopColor: "#FF5E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746912,
    stopColor: "#FF4F7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 136.474,
    y1: 73.3231,
    x2: 118.516,
    y2: 77.469,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37405,
    stopColor: "#FF5E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746912,
    stopColor: "#FF4F7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 154.094,
    y1: 80.1487,
    x2: 128.75,
    y2: 64.3165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC200",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.203,
    stopColor: "#FFBB00",
    stopOpacity: 0.203
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499,
    stopColor: "#FFA700",
    stopOpacity: 0.499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#FF8800",
    stopOpacity: 0.852
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 161.855,
    y1: 60.3685,
    x2: 89.2764,
    y2: 77.1246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37405,
    stopColor: "#FF5E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746912,
    stopColor: "#FF4F7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFABBF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 156.044,
    y1: 62.4984,
    x2: 143.43,
    y2: 7.8631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.469927,
    stopColor: "#FF8792"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.727954,
    stopColor: "#FF85A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFA2B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 163.353,
    y1: 70.2708,
    x2: 91.5225,
    y2: 86.8542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9D74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37405,
    stopColor: "#FF5E6D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746912,
    stopColor: "#FF4F7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6D90"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 240,
    height: 240,
    xlinkHref: "data:image/png;base64,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"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgNoNotification);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/No-notification.282a95498f1eedcc3bce78b8e101ec0a.svg";